import React from 'react';

const manifesto = [
  {
    num: '01',
    statement: 'On écrit du code qui dure.',
    detail: 'Pas de démos. Des applications en production, maintenues, testées, documentées.',
  },
  {
    num: '02',
    statement: 'On livre des produits, pas des slides.',
    detail: 'Chaque projet se termine par un logiciel que vos équipes utilisent vraiment — pas par un rapport.',
  },
  {
    num: '03',
    statement: 'On est pionniers tech en Mauritanie.',
    detail: 'Dashboards temps réel, IA générative, intégrations complexes. On amène les standards mondiaux ici.',
  },
];

const Enhanced3DAbout: React.FC = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-inner">
        {/* Header */}
        <div className="reveal about-header">
          <div className="sec-tag">Notre positionnement</div>
          <h2 className="sec-title">
            À propos de <em>MIID</em>
          </h2>
          <div className="gold-bar" />
          <p className="about-lead">
            Trois convictions qui guident chaque décision, chaque ligne de code, chaque livrable.
          </p>
        </div>

        {/* Manifesto */}
        <div className="about-manifesto">
          {manifesto.map((m, i) => (
            <div
              key={m.num}
              className={`reveal d${Math.min(i + 1, 4)} about-statement`}
              style={{ ['--i' as any]: i }}
            >
              <div className="about-statement-num">{m.num}</div>
              <div className="about-statement-body">
                <h3 className="about-statement-title">{m.statement}</h3>
                <p className="about-statement-detail">{m.detail}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer strip */}
        <div className="reveal d4 about-footer">
          <div className="about-footer-left">
            <div className="about-footer-label">MIID · Nouakchott, Mauritanie</div>
            <div className="about-footer-title">Société Mauritanienne d'Innovation et Développement</div>
          </div>
          <a href="#contact" className="btn-primary">
            Parlons de votre projet
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>

      <style>{`
        .about-section {
          padding: 7rem 0;
          background: var(--cream2);
          position: relative;
          overflow: hidden;
        }
        .about-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          position: relative;
        }
        .about-header { margin-bottom: 4rem; max-width: 600px; }
        .about-lead {
          font-family: 'Montserrat', sans-serif;
          font-size: .95rem;
          font-weight: 300;
          color: var(--ink2);
          line-height: 1.8;
        }

        .about-manifesto {
          display: flex;
          flex-direction: column;
          gap: 0;
        }
        .about-statement {
          display: grid;
          grid-template-columns: 120px 1fr;
          gap: 2.5rem;
          padding: 2.5rem 0;
          border-top: 1px solid var(--border);
          align-items: start;
        }
        .about-statement:last-child { border-bottom: 1px solid var(--border); }
        .about-statement-num {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 3.5rem;
          font-weight: 600;
          color: var(--gold);
          line-height: 1;
          font-style: italic;
        }
        .about-statement-body {
          max-width: 720px;
        }
        .about-statement-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(1.7rem, 3.2vw, 2.6rem);
          font-weight: 600;
          color: var(--ink);
          line-height: 1.25;
          margin: 0 0 .9rem;
          letter-spacing: -.01em;
        }
        .about-statement-detail {
          font-family: 'Montserrat', sans-serif;
          font-size: .92rem;
          font-weight: 300;
          color: var(--ink2);
          line-height: 1.8;
          margin: 0;
          max-width: 600px;
        }

        .about-footer {
          margin-top: 4rem;
          padding: 2rem 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1.5rem;
        }
        .about-footer-label {
          font-family: 'Montserrat', sans-serif;
          font-size: .58rem;
          font-weight: 600;
          letter-spacing: .2em;
          text-transform: uppercase;
          color: var(--gold-dark);
          margin-bottom: .4rem;
        }
        .about-footer-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.3rem;
          font-weight: 600;
          color: var(--ink);
        }

        /* Responsive */
        @media (max-width: 760px) {
          .about-section { padding: 4.5rem 0; }
          .about-inner { padding: 0 1rem; }
          .about-statement {
            grid-template-columns: 1fr;
            gap: .8rem;
            padding: 2rem 0;
          }
          .about-statement-num { font-size: 2.4rem; }
          .about-header { margin-bottom: 2.5rem; }
          .about-footer { margin-top: 2.5rem; }
        }
      `}</style>
    </section>
  );
};

export default Enhanced3DAbout;
